export const sidebarContent = {
  see: "Please see",
  link: "Full Prescribing Information",
};
